module.exports = __webpack_public_path__ + "img/39.6.CODm.21c7e125.png";